import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=4d7ebe8c&scoped=true&"
import script from "./TextView.vue?vue&type=script&lang=ts&"
export * from "./TextView.vue?vue&type=script&lang=ts&"
import style0 from "./TextView.vue?vue&type=style&index=0&id=4d7ebe8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7ebe8c",
  null
  
)

export default component.exports